import React from 'react';

export default function CyberCard({ children, className = '', title, action }) {
  return (
    <div className={`bg-[#0A0F1D]/60 border border-[#1A233A] rounded-xl backdrop-blur-sm overflow-hidden flex flex-col ${className}`}>
      {(title || action) && (
        <div className="px-5 py-4 border-b border-[#1A233A] flex justify-between items-center bg-[#050914]/40">
          {title && <h3 className="text-xs uppercase tracking-widest text-[#8A95A5] font-semibold">{title}</h3>}
          {action && <div>{action}</div>}
        </div>
      )}
      <div className="p-5 flex-1">
        {children}
      </div>
    </div>
  );
}